import React from "react";
import { ContactPanelWithParallax } from "../components/collections/ContactPanelWithParallax";

export const ContactPanel = () => <ContactPanelWithParallax />;
